// API resimlerini cache'lemek için service worker kaydı.
export function registerImageCacheSW() {
  if (!("serviceWorker" in navigator)) return;

  // Production veya localhost dışında çalıştır. CRA dev server'da da çalışır,
  // sadece HTTPS veya localhost gerekir.
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      // Sessiz geç; site SW olmadan da çalışır
      console.warn("Image cache SW registration failed:", err);
    });
  });
}
